export function getHomeUrl(text, useAnalogs) {
    return `/home?text=${text}&useAnalogs=${useAnalogs}`;
}
